import React from "react"
import PropTypes from "prop-types"
import { breakpoints } from "../../../theme"
import styled from "styled-components"

const Grid = styled.div`
  max-width: 100%;
  display: grid;
  grid-gap: 24px;

  @media (min-width: ${breakpoints.medium}px) {
    grid-gap: 48px;
    grid-template-columns: repeat(${props => props.$count}, 1fr);
  }
`

const Columns = ({ count, contents, children }) => {
  return (
    <Grid $count={count}>
      {children ||
        contents.map((item, i) => (
          <div key={i}>
            {item.title && <h3>{item.title}</h3>}
            {item.content && <div>{item.content}</div>}
          </div>
        ))}
    </Grid>
  )
}

Columns.propTypes = {
  count: PropTypes.number,
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.element),
        PropTypes.element,
      ]),
    })
  ),
}

Columns.defaultProps = {
  count: 2,
}

export { Columns }
